import MapPin, { MapIconType } from '../pin/MapPin';
import {
  getMapPinPropsFromStatusCode,
  WfOperationStatus,
} from 'src/api/wf/models/enums/WfOperationtStatus';

function WF_SitesIcon(reserved: boolean, statusId: WfOperationStatus, sectionCode: string) {
  const isElecare = sectionCode === '91';

  const statusBasedProps = getMapPinPropsFromStatusCode(statusId);

  const mapPinProps = isElecare
    ? { iconType: MapIconType.elecare, reserved, ...statusBasedProps }
    : reserved
      ? { ...statusBasedProps, dotColor: 'bg-black' }
      : statusBasedProps;

  return <MapPin {...mapPinProps} />;
}

export default WF_SitesIcon;
